/**
 * @des 更換錯誤圖片
 * @param {element} img element
 * @returns {null} 更改 event 圖片為預設圖片
 */
export function setDefaultImg(event) {
  const defaultImg = require('@/assets/break.svg');
  event.target.src = defaultImg;
}
